import { useState } from '@hookstate/core';
import LoaderState from '../state/LoaderState';

export default function useLoaderState() {
  const state = useState(LoaderState);

  return {
    get loading() {
      return state.get();
    },
    dispatchLoading(val: boolean) {
      state.set(val);
    },
    toggleLoading() {
      state.set((val: boolean) => !val);
    },
  };
}
